export default __webpack_public_path__ + "static/media/convert-ecredit-to-epoint-step5.809172c0.png";